import { CloseOutlined } from '@ant-design/icons';
import React from 'react';
import styled from 'styled-components';
import { useDetectIframe } from '@guuru/chat-web';
import events from '@guuru/events-web';

const Button = styled.button`
  cursor: pointer;
  font-size: 1.6em;
  border: none;
  background: none;
  color: ${({ theme }) => theme.onPrimaryColor};
  line-height: 1;
  padding: 0;
  margin: 0;
  position: relative;
  right: 0.5rem;

  @media (width: 370px) {
    display: none !important;
  }

  @media (min-width: 461px), (min-width: 370px) and (max-height: 631px) {
    display: none;
  }

  @media (max-width: 600px) {
    display: block;
  }

  @media (width: 375px) and (min-height: 547px) {
    display: block;
  }
`;

const CloseButton = function () {
  const inIframe = useDetectIframe();

  return (
    inIframe && (
      <Button onClick={() => events.closeChat()}>
        <CloseOutlined />
      </Button>
    )
  );
};

export default CloseButton;
